import { useEffect, useRef } from "react";
import { Image, TextLine, Button, FadeTranstion } from '@/components';
import { useNavigate, useLocation } from "react-router-dom";
import { useMobile } from '@/hooks';
import { scrollIntoView } from "@/utils";
import emitter from '@/event';
import { trackContactClick } from "@/lib/analytics";
import pricehunter1 from "@/assets/images/pricehunter1.svg";
import pricehunter2 from "@/assets/images/pricehunter2.svg";
import pricehunter3 from "@/assets/images/pricehunter3.svg";
import pricehunter4 from "@/assets/images/pricehunter4.svg";
import avatar from "@/assets/images/pricehunter-avatar.png";
import TodayDeal from "@/assets/images/today-deal.png";
import "./style.scss"
import "./style.mobile.scss"

function PriceHunter() {
    const navigate = useNavigate();
    const [ isMobile ] = useMobile();
    const location = useLocation();
    const el = useRef<HTMLElement>(null);
    useEffect(() => {
        const scrollHandler = () => {
            scrollIntoView(el.current as HTMLDivElement);
        };
        emitter.on("SCROLL_TO_PRICE_HUNTER", scrollHandler);
        return () => {
            emitter.on("SCROLL_TO_PRICE_HUNTER", scrollHandler);
        };
    }, []);

    useEffect(() => {
        if (location.pathname === "/price-hunter") {
            console.log('el', el.current)
            setTimeout(() => {
                scrollIntoView(el.current as HTMLDivElement);
            }, 20)
        }
    }, [location.pathname]);
    const list1 = [
        {
            image: pricehunter1,
            content: "Cross-Brand & Cross-Market Comparison: The tool doesn’t just monitor your catalog — it compares identical or similar products across multiple brands and marketplaces, helping identify competitive pricing or potential arbitrage opportunities."
        },
        {
            image: pricehunter2,
            content: "Smart Discount & Deal Detection: Price Hunter automatically identifies applicable discounts, promo codes, and sale windows — allowing users (or merchants) to grab the best possible net price (after discount, tax, shipping)."
        },
        {
            image: pricehunter3,
            content: "24/7 Automated Price Monitoring: Price Hunter runs around the clock — continuously tracking thousands of SKUs, catalog updates, discounts, and promotions across all connected merchants."
        },
        {
            image: pricehunter4,
            content: "Instant Alerts & Historical Price Data: Merchants or buyers can set custom price-drop thresholds (e.g. 5%, 10%, 25%) and receive instant notifications (email / SMS / push) when your items go on sale, or when a competing listing undercuts you. Also gives full price-history charts to help understand pricing trends over time."
        }
    ];
    const list2 = [
        {
            title: 'Stay Competitive — Automatically',
            content: "Instantly see when competitors drop prices and respond with smart, real-time adjustments."
        },
        {
            title: 'Increase Margin & Revenue',
            content: "Use accurate price-history data and alerts to optimize discount timing and maximize profit."
        },
        {
            title: 'Zero Manual Work',
            content: "Eliminate spreadsheets and manual monitoring — Price Hunter tracks everything 24/7."
        },
        {
            title: 'Run Smarter Promotions',
            content: "Enable data-driven flash sales, dynamic pricing, and better inventory decisions."
        },
        {
            title: 'Win Value-Driven Shoppers',
            content: "Competitive, AI-optimized pricing helps your products rank higher and convert more customers."
        }
    ];

    const list3 = [
        {
            image: pricehunter1,
            content: "Cross-Brand & Cross-Market Comparison: The tool doesn’t just monitor your catalog — it compares identical or similar products across multiple brands and marketplaces, helping identify competitive pricing or potential arbitrage opportunities."
        },
        {
            image: pricehunter3,
            content: "24/7 Automated Price Monitoring: Price Hunter runs around the clock — continuously tracking thousands of SKUs, catalog updates, discounts, and promotions across all connected merchants."
        },
        {
            image: pricehunter2,
            content: "Smart Discount & Deal Detection: Price Hunter automatically identifies applicable discounts, promo codes, and sale windows — allowing users (or merchants) to grab the best possible net price (after discount, tax, shipping)."
        },
        {
            image: pricehunter4,
            content: "Instant Alerts & Historical Price Data: Merchants or buyers can set custom price-drop thresholds (e.g. 5%, 10%, 25%) and receive instant notifications (email / SMS / push) when your items go on sale, or when a competing listing undercuts you. Also gives full price-history charts to help understand pricing trends over time."
        }
    ];

    return (
        <section className="pricehunter-container" ref={el}>
            <div className="pricehunter-card">
                <Image className="avatar" src={avatar}></Image>
                <p className="title">Price Hunter{isMobile ? null : <span className="point"></span>}</p>
                {isMobile ? <p className="content">
                    AI Price Hunter is an intelligent, AI-powered price tracking and deal-finding engine that constantly scans global brand catalogs and marketplaces, analyzing price changes in real time.
                </p> : <p className="content">
                    <TextLine>AI Price Hunter</TextLine> is an intelligent, AI-powered price tracking and deal-<br/>
                    finding engine that constantly scans global brand catalogs and<br/>
                    marketplaces, analyzing price changes in real time.
                </p>}
                <p className="subtitle">
                    Why It’s a Powerful Tool
                </p>
                <FadeTranstion>
                    <ul className="list1">
                        {(isMobile ? list3 : list1).map((item, index) => (
                            <li className="pricehunter-list1-item" key={index}>
                                <Image className="pricehunter-list1-img" src={item.image}></Image>
                                <p className="text-content">{item.content}</p>
                            </li>
                        ))}
                    </ul>
                </FadeTranstion>
                <p className="subtitle">
                    What Merchants Gain by Deploying Price Hunter
                </p>
                <div className='list-wrap'>
                    {isMobile ? null :
                        <FadeTranstion>
                            <Image className="today-deal" src={TodayDeal}></Image>
                        </FadeTranstion>}
                    <FadeTranstion>
                        <ul className="list2">
                            {list2.map((item, index) => (
                                <li className="pricehunter-list2-item" key={index}>
                                    <div className="num-index">0{index + 1}</div>
                                    <div className='list-content'>
                                        <p className="text-title">{item.title}</p>
                                        <p className="text-content">{item.content}</p>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </FadeTranstion>
                </div>
                <Button onClick={() => {
                    trackContactClick("PriceHunter");
                    navigate("/contact-us");
                }}>Contact Us</Button>
            </div>
        </section>
    )
}

export default PriceHunter